var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bradesco"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"bradesco__line"}),_c('img',{attrs:{"src":_vm.BradescoIcon}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }